import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["name", "id", "autocomplete", "autofocus", "placeholder", "disabled", "aria-invalid", "aria-describedby", "aria-autocomplete"]
const _hoisted_2 = ["name", "id", "autocomplete", "autofocus", "placeholder", "disabled", "aria-invalid", "aria-describedby"]

import { useInputModel } from '@src/components/shared/form_elements/useInputModel';

interface Props {
	inputType: 'text' | 'textarea';
	name: string;
	modelValue: string | number;
	autocomplete?: string;
	autofocus?: boolean;
	inputId: string;
	placeholder: string;
	hasMessage: boolean;
	hasError?: boolean;
	disabled?: boolean;
	ariaDescribedby?: string | undefined;
	ariaAutocomplete?: 'none' | 'inline' | 'list' | 'both';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextFormInput',
  props: {
    inputType: {},
    name: {},
    modelValue: {},
    autocomplete: { default: 'on' },
    autofocus: { type: Boolean },
    inputId: {},
    placeholder: {},
    hasMessage: { type: Boolean },
    hasError: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    ariaDescribedby: {},
    ariaAutocomplete: {}
  },
  emits: [ 'update:modelValue', 'focus', 'blur', 'input', 'keyup', 'keydown' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const inputModel = useInputModel<string | number>( () => props.modelValue, props.modelValue, emit );

const onFocus = ( event: Event ): void => emit( 'focus', event );
const onBlur = ( event: Event ): void => emit( 'blur', event );
const onInput = ( event: Event ): void => emit( 'input', event );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.inputType === 'text')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          name: __props.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null)),
          id: __props.inputId,
          type: "text",
          autocomplete: __props.autocomplete,
          autofocus: __props.autofocus,
          placeholder: __props.placeholder,
          disabled: __props.disabled ? true : null,
          "aria-invalid": __props.hasError,
          "aria-describedby": __props.ariaDescribedby,
          "aria-autocomplete": __props.ariaAutocomplete,
          onBlur: onBlur,
          onFocus: onFocus,
          onInput: onInput
        }, null, 40, _hoisted_1)), [
          [_vModelText, _unref(inputModel)]
        ])
      : _createCommentVNode("", true),
    (__props.inputType === 'textarea')
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 1,
          name: __props.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null)),
          id: __props.inputId,
          autocomplete: __props.autocomplete,
          autofocus: __props.autofocus,
          placeholder: __props.placeholder,
          disabled: __props.disabled ? true : null,
          "aria-invalid": __props.hasError,
          "aria-describedby": __props.ariaDescribedby,
          onBlur: onBlur,
          onFocus: onFocus,
          onInput: onInput
        }, null, 40, _hoisted_2)), [
          [_vModelText, _unref(inputModel)]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})